import { render, staticRenderFns } from "./BiddingProductList.vue?vue&type=template&id=5db539c4&"
import script from "./BiddingProductList.vue?vue&type=script&lang=js&"
export * from "./BiddingProductList.vue?vue&type=script&lang=js&"
import style0 from "./BiddingProductList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BiddingProductList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports